/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import accusationIcon from "@/src/assets/icons/progress/icon_progressbar_document.svg";
import carIcon from "@/src/assets/icons/progress/icon_progressbar_car.svg";
import documentsIcon from "@/src/assets/icons/progress/icon_progressbar_vertrag_upload.svg";

const progressBarSteps = [
  {
    key: "accident",
    name: "Unfall",
    icon: accusationIcon,
  },
  {
    key: "damage",
    name: "Schaden",
    icon: carIcon,
  },
  {
    key: "documents",
    name: "Unterlagen",
    icon: documentsIcon,
  },
];

export default progressBarSteps;
